<template>
    <modal @close="closeModal" dusk="dnssec-disable-confirm">
        <div class="u-margin-bottom">
            <div class="u-margin-bottom">
            {{
                trans('domain.whois.private-disable-confirm', {
                    domain: this.domain
                })
            }}
            </div>

            <div class="page-block__item">
                <div class="page-block__item-content">
                    <div class="layout__item">
                        <checkbox
                            v-model="confirmed"
                            :label="trans('domain.whois.private-disable-confirm-checkbox')"
                            name="private_whois_confirm"
                            class="u-margin-bottom-narrow"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="modal__nav">
            <button class="btn btn--ghost-gray | u-margin-right" @click="closeModal">
                {{ trans('action.cancel') }}
            </button>
            <button class="btn btn--blue-record" type="submit" @click="disablePrivateWhois" :disabled="!confirmed">
                {{ trans('domain.whois.private-disable') }}
            </button>
        </div>
    </modal>
</template>

<script>
import { EventBus } from 'relapp-event';
import { Modal } from 'relapp-modal';
import { WhoisApi } from 'relapp-technical-management';

export default {
    components: {
        Modal
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            confirmed: false
        };
    },
    methods: {
        /**
         * Close the modal.
         */
        closeModal() {
            this.$emit('close');
        },

        /**
         * Disable private whois for domain.
         */
        disablePrivateWhois() {
            WhoisApi.disablePrivateWhois(this.domain)
                .then(() => {
                    EventBus.$emit('notification', {
                        type: 'success',
                        message: trans('action.updated')
                    });

                    // Refresh
                    WhoisApi.get(this.domain);
                })
                .catch(() => {
                    EventBus.$emit('notification', {
                        type: 'error',
                        message: trans('message.error.general')
                    });
                });

            this.$emit('close');
        }
    }
};
</script>
